(function(appSetup) {

	appSetup.roleConstructor = function (type, allowedActions) {
		var roles = {
			guest: {
				isGuest: true
			},
			user: {
				isUser : true
			},
			consultant: {
				isUser: true
			},
			epc: {
				isUser: true,
				isQuotesAllowed: true,
			},
			external: {
				isUser: true,
				isQuotesAllowed: true,
				isOrdersAllowed: true
			},
			internal: {
				isUser: true,
				isQuotesAllowed: true,
				isOrdersAllowed: true,
				isUnitsAllowed: true
			},
			superUser: {
				isUser: true,
				isQuotesAllowed: true,
				isOrdersAllowed: true,
				isUnitsAllowed: true,
				isAdmin: true
			}
		};
		this.type = type;
		this.flags = roles[type];
	};

	window.appSetup = appSetup;

})(window.appSetup || {});